import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

const DateSelect = ({
  policiesData,
  index,
  setIndex,
}: {
  policiesData: PoliciesData[];
  index: number;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const selectRef = useRef<HTMLDivElement | null>(null);

  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleOutsideClose = (e: { target: any }) => {
      if (open && !selectRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', handleOutsideClose);

    return () => document.removeEventListener('click', handleOutsideClose);
  }, [open]);

  return (
    <div className={classNames('policy-dateSelect', { active: open })}>
      <div
        ref={selectRef}
        onClick={() => setOpen(!open)}
        className="policy-dateSelect-item"
      >
        <span>
          {getDateFormat(policiesData[index].date)}{' '}
          {index === 0 && '(Latest Update)'}
        </span>
        <aside />
      </div>
      <div className="policy-dateSelect-list">
        {policiesData.map((data, i) => (
          <div
            onClick={() => {
              setIndex(i);
            }}
            className="policy-dateSelect-item"
          >
            <span>
              {getDateFormat(data.date)} {i === 0 && '(Latest Update)'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DateSelect;

const getDateFormat = (date: string) => {
  const d = new Date(date);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};
